import template from './confirm_account.html';

//Instantiate Page Variables
var ConfirmAccountViewModel = function(page)
{
	this.page = page;

	this.installation_uuid = ko.observable('');

	this.activate = function() {

		$.postJSON('psam/api/account/installation/activate',
			{ installation_uuid: this.installation_uuid() }
		)
		.then( res => {
			if (res.status === 'ERROR') {
				if (res.message === 'Installation already activated.') {
					Grape.alert({
						type: 'info',
						title: 'Account Activation',
						message: 'Account already activated, please login to manage your account.',
						onClose: Grape.navigate_to_default
					});
					return;
				}

				Grape.alert_api_error(res);
			}

			this.monitor_installation();
		});

	};

	this.monitor_installation = () => {
		Grape.show_dialog(
			'ConfirmAccountDialog',
			{ installation_uuid: this.installation_uuid() },
			{ onClose: Grape.navigate_to_default }
		);
	};
}

//Handle interaction with page
var ConfirmAccountPage = function(bindings) {
	this.bindings = bindings;
	this.viewModel = new ConfirmAccountViewModel(this);
	this.name = 'ConfirmAccountPage';

	//Event (Post/After): Load once
	this.init = () => {
		document.title = 'Activate Account';

		this.viewModel.installation_uuid(this.bindings.token);

	};

	//Event (Post/After): Refresh page data
	this.updateData = function() {};

	//Event (Pre/Before): Remove
	this.teardown = function() {
	};

};


export default {
	route: '[/]accounts/confirm_account/',
	page_class: ConfirmAccountPage,
	template: template
};
